import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const AlertFilterBar = ({ filters, onFiltersChange }) => {
  const priorityOptions = [
    { value: 'all', label: 'جميع الأولويات' },
    { value: 'urgent', label: 'عاجل' },
    { value: 'high', label: 'عالية' },
    { value: 'medium', label: 'متوسطة' },
    { value: 'low', label: 'منخفضة' }
  ];

  const statusOptions = [
    { value: 'all', label: 'جميع الحالات' },
    { value: 'unread', label: 'غير مقروء' },
    { value: 'acknowledged', label: 'تم الاطلاع' },
    { value: 'in_progress', label: 'قيد التنفيذ' },
    { value: 'read', label: 'مقروء' }
  ];

  const staffOptions = [
    { value: 'all', label: 'جميع الموظفين' },
    { value: 'staff_1', label: 'سارة أحمد' },
    { value: 'staff_2', label: 'أحمد محمد' },
    { value: 'staff_3', label: 'محمد خالد' }
  ];

  return (
    <div className="bg-card rounded-lg border border-border shadow-warm p-4 mb-4">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Filter" size={18} className="text-primary" />
        <h3 className="text-sm font-heading font-semibold text-foreground">تصفية التنبيهات</h3>
      </div>
      <div className="space-y-3">
        <Input
          type="text"
          placeholder="بحث في التنبيهات..."
          value={filters?.search}
          onChange={(e) => onFiltersChange({ ...filters, search: e?.target?.value })}
        />
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
          <Select
            options={priorityOptions}
            value={filters?.priority}
            onChange={(value) => onFiltersChange({ ...filters, priority: value })}
          />
          <Select
            options={statusOptions}
            value={filters?.status}
            onChange={(value) => onFiltersChange({ ...filters, status: value })}
          />
          <Select
            options={staffOptions}
            value={filters?.assignedStaff}
            onChange={(value) => onFiltersChange({ ...filters, assignedStaff: value })}
          />
        </div>
      </div>
    </div>
  );
};

export default AlertFilterBar;